/** Clipboard API requires a secure context (HTTPS / localhost). Fallback for plain HTTP LAN URLs. */
export function copyTextToClipboard(text: string): Promise<boolean> {
  const clip = navigator.clipboard;
  if (typeof clip?.writeText === 'function') {
    return clip.writeText(text).then(() => true).catch(() => Promise.resolve(copyViaExecCommand(text)));
  }
  return Promise.resolve(copyViaExecCommand(text));
}

function copyViaExecCommand(text: string): boolean {
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    ta.style.top = '0';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, text.length);
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
